import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import axios from '../config/axiosConfig'; 
import { useTranslation } from '../contexts/TranslationContext';
import { FaCheckCircle, FaTimesCircle, FaSpinner } from 'react-icons/fa';
import './VerifyEmail.css';

const VerifyEmail = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const [status, setStatus] = useState('verifying');
  const [message, setMessage] = useState('');
  
  useEffect(() => {
    const verifyEmail = async () => {
      // Get token from URL
      const queryParams = new URLSearchParams(location.search);
      const token = queryParams.get('token');
      
      if (!token) {
        setStatus('error');
        setMessage(t('verificationTokenMissing') || 'Verification token is missing');
        return;
      }
      
      try {
        setStatus('verifying');
        
        // Call server API to verify token
        const response = await axios.post('https://hsn.urugowoc.org.rw/backend/api/verify-email', {
          token: token
        });
        
        if (response.data.success) {
          setStatus('success');
          setMessage(response.data.message || t('verificationSuccess') || 'Email verified successfully!');
          
          // Auto-redirect to login page after 5 seconds
          setTimeout(() => {
            navigate('/login', { 
              state: { 
                message: response.data.message,
                email: response.data.email
              }
            });
          }, 5000);
        }
      } catch (error) {
        setStatus('error');
        const errorMessage = error.response?.data?.error || 
                           error.response?.data?.message || 
                           t('verificationFailed') || 
                           'Verification failed';
        setMessage(errorMessage);
        
        // Redirect to registration page on error
        setTimeout(() => {
          navigate('/register', { 
            state: { 
              error: errorMessage
            }
          });
        }, 5000);
      }
    };
    
    verifyEmail();
  }, [location, navigate, t]);
  
  return (
    <div className="verify-email-container">
      <div className="verify-email-card">
        <div className="verify-email-icon">
          {status === 'verifying' && <FaSpinner className="spinner" />}
          {status === 'success' && <FaCheckCircle className="success" />}
          {status === 'error' && <FaTimesCircle className="error" />}
        </div>
        
        <h2 className="verify-email-title">
          {status === 'verifying' && (t('verifyingEmail') || 'Verifying Email')}
          {status === 'success' && (t('verificationSuccess') || 'Verification Successful')}
          {status === 'error' && (t('verificationFailed') || 'Verification Failed')}
        </h2>
        
        <p className="verify-email-message">{message}</p>
        
        <div className="verify-email-actions">
          {status === 'success' && (
            <>
              <p className="redirect-message">
                {t('redirectingToLogin') || 'Redirecting to login page in 5 seconds...'}
              </p>
              <button 
                className="btn btn-primary"
                onClick={() => navigate('/login')}
              >
                {t('goToLogin') || 'Go to Login'}
              </button>
            </>
          )}
          
          {status === 'error' && (
            <>
              <p className="redirect-message">
                {t('redirectingToRegister') || 'Redirecting to registration page in 5 seconds...'}
              </p>
              <button 
                className="btn btn-outline"
                onClick={() => navigate('/register')}
              >
                {t('goToRegister') || 'Go to Register'}
              </button>
            </>
          )}
          
          {status === 'verifying' && (
            <div className="loading-spinner">
              <FaSpinner className="spinner" />
              <p>{t('pleaseWait') || 'Please wait...'}</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default VerifyEmail;